// The staff roles, from Employee to School Admin, each a darker green; School Admin is the green of the main menu bar.
// 'Senior Member of Staff' does not fit on a laptop card, so the card says 'Senior Staff' with the full name in the hover.
export const STAFF_ROLES = {
    Employee: {label: 'Employee', background: '#DDF4EF', text: '#0B5C50'},
    MemberOfStaff: {label: 'Member of Staff', background: '#A3E0D4', text: '#0A4F45'},
    SeniorMemberOfStaff: {label: 'Senior Staff', title: 'Senior Member of Staff', background: '#58C7B3', text: '#06372F'},
    SchoolAdmin: {label: 'School Admin', background: '#0DAD95', text: '#FFFFFF'}
};
